import React from 'react';
import { arrayOf, shape, string, func, bool } from 'prop-types';
import classnames from 'classnames';

import { Button } from '~/elements';

import styles from './ProductsList.scss';
import { formatRoomsPlural } from '~/ocab-services/measure/utils/formatters';

export const ProductsList = ({
  products,
  onClickRemoveHandler = null,
  hasProductControls = true,
  onEditClickHandler,
}) => (
  <div
    data-testid="ProductsList"
    className={classnames(styles.ProductsList, {
      [styles.ProductsList_withoutProductControls]: !hasProductControls,
    })}
  >
    {products.map((product, productIndex) => {
      const { productId, name, selectionType, quantity, information } = product;

      return (
        <div
          key={productId || `productItem${productIndex}`}
          className={styles.ProductItem}
          data-testid="ProductItem"
        >
          <div className={styles.ProductDetails}>
            <strong data-testid="ProductItemName">{name}</strong>
            <p data-testid="ProductItemDescription">
              {(selectionType && selectionType?.name && formatRoomsPlural(selectionType.name)) ||
                'items'}

              {` ${quantity}`}
            </p>
          </div>
          <div className={styles.ProductDetails}>
            <strong data-testid="ProductInfoTitle">Product information</strong>
            <p data-testid="ProductInformation">{information}</p>
          </div>
          {hasProductControls && (
            <div className={styles.ProductControls} data-testid="ProductControls">
              <Button
                view="underlined"
                onClick={() => onEditClickHandler(product)}
                data-testid="EditProductButton"
              >
                Edit
              </Button>
              <Button
                view="underlined"
                onClick={() => onClickRemoveHandler(productId)}
                data-testid="RemoveProduct"
              >
                Remove
              </Button>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export const MemoizedProductsList = React.memo(ProductsList);

ProductsList.propTypes = {
  products: arrayOf(
    shape({
      id: string,
      name: string,
      price: string,
    }),
  ).isRequired,
  onClickRemoveHandler: func,
  onEditClickHandler: func.isRequired,
  hasProductControls: bool,
};
